import { css, FlattenSimpleInterpolation } from 'styled-components';

export const scrollbar = (
  bg: string,
  matchBg: string,
  thumb: string,
  width = '11px',
  includeBorderRadius = true,
): FlattenSimpleInterpolation => css`
  scrollbar-width: thin;
  scrollbar-color: ${thumb} ${bg};

  &::-webkit-scrollbar {
    width: ${width};
    height: ${width};
    scrollbar-width: ${width};
  }

  &::-webkit-scrollbar-track {
    border-radius: ${includeBorderRadius ? '10px' : '0px'};
    background: ${bg};
  }

  &::-webkit-scrollbar-thumb {
    background-color: ${thumb};
    border-radius: 6px;
    border: 3px solid ${matchBg};
  }
`;
